import axios from 'axios'
import { COUNTRY } from '../../../const/constants'
import { sortReferrsByDate } from '../../../utils/utils'

export const getReferidos = async (user: Record<string, string>, country: string) => {
  const fetchUrl = country !== COUNTRY.AR ? '/portaEstado/referidos' : '/psr/api/prospectos'
  let data
  if (country !== COUNTRY.AR) {
    const response = await axios.post(fetchUrl, { customerId: user.extCode, telefonoKiosco: user.posNumber })
    const orderedResults = response.data.sort(sortReferrsByDate)
    data = orderedResults.map((referr: Record<string, string>) => ({
      nombre: referr.ppp_name,
      telefono: referr.ppp_nim,
      email: referr.ppp_email,
      estado: referr.ppp_status_app,
      negocio: referr.ppp_product,
      documento: referr.ppp_document,
      fechaIngreso: referr.ppp_order
    }))
  } else {
    const response = await axios.get(`${fetchUrl}?kiosco=${user?.posNumber}&customerId=${user?.extCode}`)
    data = response.data
  }
  return data
}
